import { render, staticRenderFns } from "./GetStartedSection.vue?vue&type=template&id=b6a06a06&scoped=true"
import script from "./GetStartedSection.vue?vue&type=script&lang=js"
export * from "./GetStartedSection.vue?vue&type=script&lang=js"
import style0 from "./GetStartedSection.vue?vue&type=style&index=0&id=b6a06a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a06a06",
  null
  
)

export default component.exports